/**
 * 页面文案词典 —— 中文（源语言）
 * 第六批：云端通讯录（Contacts/index）—— 与电子表格打通
 */
export default {
  '云端通讯录': '云端通讯录',
  '通讯录总人数': '通讯录总人数',
  '平台用户': '平台用户',
  '已注册': '已注册',
  '未注册': '未注册',
  '全球ID': '全球ID',
  '来源': '来源',
  '导入 CSV': '导入 CSV',
  '导出 CSV': '导出 CSV',
  '下载模板': '下载模板',
  '新增联系人': '新增联系人',
  '编辑联系人': '编辑联系人',
  '确认删除？': '确认删除？',
  '多个标签用逗号分隔': '多个标签用逗号分隔',
  '导入成功': '导入成功',
  '导入失败': '导入失败',
  '导出成功': '导出成功',
  '导出失败': '导出失败',
  '保存成功': '保存成功',
  '保存失败': '保存失败',
  '已删除': '已删除',
  '删除失败': '删除失败',
};
